var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebNoTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5458",
    "data-name": "Group 5458",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.323,
    height: 44.347,
    viewBox: "0 0 41.323 44.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M48.726,8.9H9.8a1.217,1.217,0,0,0-1.2,1.2V42.674a1.217,1.217,0,0,0,1.2,1.2h8.983a10.546,10.546,0,0,0,20.961,0h8.983a1.185,1.185,0,0,0,1.2-1.2V10.1A1.185,1.185,0,0,0,48.726,8.9Zm-29.3,2.455H47.478V8.95H11v2.405Zm9.832,39.486A8.143,8.143,0,1,1,37.4,42.724,8.153,8.153,0,0,1,29.262,50.842Zm10.481-9.37a10.546,10.546,0,0,0-20.961,0H11V11.405H47.478V41.471Z",
    transform: "translate(-8.6 -8.9)",
    fill: "#36495a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161",
    transform: "translate(17.436 30.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4157",
    "data-name": "Group 4157"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x2: 6.551,
    y2: 6.551,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#36495a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    y1: 6.551,
    x2: 6.551,
    fill: "none",
    stroke: "#36495a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164",
    transform: "translate(5.039 4.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11140",
    "data-name": "Path 11140",
    d: "M45.161,29.823H60.985a1.461,1.461,0,0,0,0-2.923H45.161A1.462,1.462,0,0,0,43.7,28.361,1.532,1.532,0,0,0,45.161,29.823Z",
    transform: "translate(-31.7 -24.594)",
    fill: "#36495a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11141",
    "data-name": "Path 11141",
    d: "M21.764,29.417a1.461,1.461,0,0,0,2.117,0l4.334-4.636A1.461,1.461,0,1,0,26.1,22.765l-3.276,3.477-1.209-1.31A1.461,1.461,0,0,0,19.5,26.948Z",
    transform: "translate(-19.087 -22.323)",
    fill: "#36495a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11142",
    "data-name": "Path 11142",
    d: "M45.161,50.023H60.985a1.461,1.461,0,0,0,0-2.923H45.161A1.462,1.462,0,0,0,43.7,48.561,1.532,1.532,0,0,0,45.161,50.023Z",
    transform: "translate(-31.7 -34.614)",
    fill: "#36495a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11143",
    "data-name": "Path 11143",
    d: "M21.764,49.617a1.461,1.461,0,0,0,2.117,0l4.334-4.636A1.461,1.461,0,1,0,26.1,42.965l-3.276,3.477-1.209-1.31A1.461,1.461,0,0,0,19.5,47.148Z",
    transform: "translate(-19.087 -32.344)",
    fill: "#36495a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebNoTaskIcon);
export default __webpack_public_path__ + "static/media/Web_NoTask_Icon.da1b34c91ca172b344e758d8f64d6d41.svg";
export { ForwardRef as ReactComponent };